import { render, staticRenderFns } from "./Agendamento.vue?vue&type=template&id=0a0942c2&scoped=true&"
import script from "./Agendamento.vue?vue&type=script&lang=js&"
export * from "./Agendamento.vue?vue&type=script&lang=js&"
import style0 from "./Agendamento.vue?vue&type=style&index=0&id=0a0942c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0942c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFadeTransition,VRow})
